import styled from 'styled-components';

export const Label = styled.label`
  display: inline-block;
  font-family: 'GT-America-Standard-Light', sans-serif;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 15px;
  width: 100%;
`;

export const TabContentMessage = styled.p`
  color: #8e8e8e;
  font-weight: 600;
  line-height: 3;
  display: block;
  text-align: center;
  vertical-align: middle;
  background: #ffffff;
  height: 655px;
  padding-top: 150px;
`;
